import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline'
import type { IOrderWithCounts } from '../../../../Model/index.js'
import { Link } from 'react-router-dom'
import { DateWidget } from '../../../Common/DateWidget.js'
import { AmpliconWidget } from '../../OrderManagementPage/AmpliconWidget.tsx'
import { determineOrderStateForList } from '../../../../Util/OrderState.js'
import { getProcessingTypeAccentBg, getProcessingTypeLabel } from '../../../../Util/processingType.ts'
import { TooltipTrigger } from '../../../../Provider/TooltipManager.tsx'
import { DASHBOARD_WIDGET_CLASS } from './dashboardUtils.ts'
import { orderToStateWidget } from '../../OrderManagementPage/OrderStateWidget.js'

export const RecentOrdersWidget = ({ recentOrders }: { recentOrders: IOrderWithCounts[] }) => (
  <section className={`${DASHBOARD_WIDGET_CLASS} xl:col-span-8`}>
    <div className="mb-4 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2">
        <ClipboardDocumentListIcon className="h-5 w-5 text-slate-600" />
        <h2 className="text-lg font-semibold text-slate-900">Recent orders</h2>
      </div>
      <Link to="/order_management" className="text-sm font-medium text-slate-700 hover:text-slate-900">
        View all
      </Link>
    </div>
    <div className="space-y-2">
      {recentOrders.length > 0 ? (
        recentOrders.map((item) => {
          const date = item.order.orderCreated ?? item.order.draftCreatedAt ?? item.order.orderSubmission

          return (
            <Link
              key={item.order.id}
              to={`/order/${item.order.id}`}
              className="flex flex-col gap-3 rounded-lg border border-slate-200 bg-slate-50 p-3 transition-all hover:bg-white hover:shadow-sm md:flex-row md:items-center md:justify-between"
            >
              <div className="flex min-w-0 items-center gap-2">
                <TooltipTrigger tooltip={getProcessingTypeLabel(item.order.processingType)}>
                  <span className={`inline-block h-2 w-2 flex-shrink-0 rounded-full ${getProcessingTypeAccentBg(item.order.processingType)}`} />
                </TooltipTrigger>
                <div className="min-w-0">
                  <div className="truncate font-medium text-slate-900">{item.order.name}</div>
                  {item.order.description ? <div className="truncate text-xs text-slate-500">{item.order.description}</div> : null}
                </div>
              </div>
              <div className="flex flex-wrap items-center gap-3 text-sm text-slate-500">
                {orderToStateWidget(determineOrderStateForList(item.order, item.hasBlockingItems), null)}
                <AmpliconWidget amplicon={item.order.targetTaxonomy} showLabel={false} classNames="text-lg" />
                <span>{item.sampleCount} samples</span>
                {date ? <span className="whitespace-nowrap"><DateWidget date={date} /></span> : null}
              </div>
            </Link>
          )
        })
      ) : (
        <div className="rounded-lg border border-dashed border-slate-300 p-6 text-sm text-slate-500">No orders yet.</div>
      )}
    </div>
  </section>
)
